// extracted by mini-css-extract-plugin
export default {"fileWrapperUploader":"UploadDragAndDrop_fileWrapperUploader__hZxQC"};